export function contrastFor(hex) {
    if (!hex || hex.length < 6) return "#141414";
    const h = hex.replace("#", "");
    const r = parseInt(h.substr(0, 2), 16);
    const g = parseInt(h.substr(2, 2), 16);
    const b = parseInt(h.substr(4, 2), 16);
    return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.45 ? "#141414" : "#ffffff";
}

// Every surface color that needs a derived on-top text color registers
// itself here — adding a new surface is a one-line map entry, not another
// `if (colors.x)` branch.
const CONTRAST_TEXT_VAR_BY_COLOR_KEY = {
    header: "--color-header-text",
    button: "--color-button-text",
    background: "--color-background-text",
    primary: "--color-primary-text",
};

function applyAdminTheme(colors) {
    if (!colors || typeof colors !== "object") return;
    Object.entries(colors).forEach(([key, value]) => {
        document.documentElement.style.setProperty(`--color-${key}`, value);

        const contrastVar = CONTRAST_TEXT_VAR_BY_COLOR_KEY[key];
        if (contrastVar && value) {
            document.documentElement.style.setProperty(contrastVar, contrastFor(value));
        }
    });
}

export { applyAdminTheme };
